<template>
  <VcLayout class="mobile-custom-instructions-input__wrapper pa-3" align-center>
    <VcTextField
      v-show="!isCustomInstructionsScreen"
      :placeholder="$t('ai_content_generator.custom_instructions.mobile_input_placeholder')"
      class="mobile-custom-instructions-input__text-field"
      @focus="$emit('focus')"
    />
    <VcTextArea
      v-show="isCustomInstructionsScreen"
      :value="value"
      :placeholder="$t('ai_content_generator.custom_instructions.mobile_input_placeholder')"
      :maxlength="1000"
      class="mobile-custom-instructions-input__textarea"
      ref="mobileInstructionsInput"
      noResize
      autoGrow
      @input="$emit('input', $event)"
      @keydown.enter="handleEnterKey"
    />
    <VcButton
      v-if="isCustomInstructionsScreen"
      icon
      small
      @click="handleGenerate"
      class="mobile-custom-instructions-input__send-button ml-2"
      :disabled="isSendButtonDisabled"
      :aria-label="$t('ai_content_generator.custom_instructions.generate_button')"
    >
      <VcIcon>icon-arrow-up</VcIcon>
    </VcButton>
  </VcLayout>
</template>

<script>
import { mapGetters } from 'vuex';

const MIN_VALID_LENGTH = 2;

export default {
  name: 'MobileCustomInstructionsInput',
  props: {
    screen: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      default: '',
    },
    screens: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('AiGeneratorStore', ['isGenerating']),
    isCustomInstructionsScreen() {
      return this.screen === this.screens.MOBILE_CUSTOM_INSTRUCTIONS;
    },
    trimmedValue() {
      return this.value?.trim() || '';
    },
    isSendButtonDisabled() {
      return this.isGenerating || this.trimmedValue.length < MIN_VALID_LENGTH;
    },
  },
  methods: {
    handleEnterKey(event) {
      if (!event.shiftKey && !this.isSendButtonDisabled) {
        event.preventDefault();
        this.handleGenerate();
      }
    },
    handleGenerate() {
      if (!this.isSendButtonDisabled) {
        this.$emit('generate');
      }
    },
    focus() {
      this.$nextTick(() => {
        const textarea = this.$refs.mobileInstructionsInput?.$el?.querySelector('textarea');
        if (textarea) {
          textarea.focus();
        }
      });
    },
  },
  watch: {
    screen(newValue) {
      if (newValue === this.screens.MOBILE_CUSTOM_INSTRUCTIONS) {
        this.focus();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mobile-custom-instructions-input__send-button {
  ::v-deep .v-icon {
    color: white !important;
  }

  &:not(:disabled) {
    background-color: var(--v-secondary-base);
  }
}

.mobile-custom-instructions-input__textarea {
  ::v-deep {
    textarea {
      max-height: 70px;
      overflow: auto;
    }

    &.VcTextArea.v-text-field .v-text-field__slot:first-child {
      margin-top: 0;
      margin-bottom: 0;
    }
  }
}
</style>
